import { AntTextArea, Select } from "components/Antd";
import { CommonButton, RippleEffect } from "components/UiElement";
import { Form, Formik } from "formik";
import validation from "./validation";

export default function ReportMemorial({
  setReportModal,
  onSubmit,
  t,
  reportCategory,
  reportCategoryLoader,
}) {
  return (
    <>
      <Formik
        initialValues={{ reportCategory: undefined, reason: "" }}
        onSubmit={(e) => onSubmit(e)}
        enableReinitialize
        validationSchema={validation()}
      >
        {(props) => {
          return (
            <Form>
              <div className="reportModal_body">
                {/* <h2>Are you sure to want to report this?</h2> */}
                <div className="form-group">
                  <label className="form-label lh-sm">
                    {t("text.theme.category")}
                  </label>
                  <Select
                    placeholder="Select Category"
                    name="reportCategory"
                    setFieldValue={props.handleChange}
                    loading={reportCategoryLoader}
                  >
                    {reportCategory?.map((category, index) => {
                      return (
                        <option key={index} value={category?.id}>
                          {category?.category}
                        </option>
                      );
                    })}
                  </Select>
                </div>
                <div className="form-group mb-0">
                  <label className="form-label lh-sm">
                    {" "}
                    {t("text.common.reasonForReport")}
                  </label>
                  <AntTextArea
                    className="form-control form-control-textarea"
                    placeholder={t("text.createMemories.typeHere")}
                    setFieldValue={props.handleChange}
                    name="reason"
                  />
                </div>
              </div>
              <div className="reportModal_footer text-end">
                <RippleEffect>
                  <CommonButton
                    className="btn btn-light"
                    onClick={() => setReportModal(false)}
                  >
                    {t("text.common.close")}
                  </CommonButton>
                </RippleEffect>
                <RippleEffect>
                  <CommonButton type="submit" className="btn btn-danger">
                    {t("text.common.sendReport")}
                  </CommonButton>
                </RippleEffect>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
